
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import workspaceFederationSaveDialogDescriptor from './WorkspaceFederationSaveDialogDescriptor.json'

export default defineComponent({
    name: 'workspace-federation-save-dialog',
    components: { Dialog },
    emits: ['close', 'save'],
    props: { visible: { type: Boolean }, federatedDataset: { type: Object } },
    data() {
        return {
            workspaceFederationSaveDialogDescriptor,
            dataset: null as any,
            labelDirty: false,
            nameDirty: false
        }
    },
    watch: {
        federatedDataset() {
            this.loadDataset()
        }
    },
    computed: {
        saveButtonDisabled(): boolean {
            return this.dataset.label.length === 0 || this.dataset.name.length === 0
        }
    },
    created() {
        this.loadDataset()
    },
    methods: {
        loadDataset() {
            this.dataset = this.federatedDataset ? { ...this.federatedDataset } : {}
        },
        closeDialog() {
            this.dataset = { ...this.federatedDataset }
            this.labelDirty = false
            this.nameDirty = false
            this.$emit('close')
        },
        saveFederation() {
            this.$emit('save', this.dataset)
        }
    }
})
